import React, {useContext, useEffect, useState} from "react";
import {RecordsManagementContext,ViewMangementContext} from "../StatesMangement/InitialiseContext";
import {Col, Row} from "bootstrap-4-react/lib/components/layout";
import axios from "axios";
import {Elink, FetchExtraStopAddresses, UpdateAddresses} from "../CommonComponents/Routes";
import Select from "react-select";
import "./Switch.css"
import Loader from "../CommonComponents/Loader";

export default () => { //this component is used to update the origin ,destination or extra stops of an estimate.
    let PageView = useContext(ViewMangementContext)
    let records = useContext(RecordsManagementContext)
    let Record = records.CP_PageDetails
    let Addresses = Record.EstimateAddress
    let OfficeAddress = Record.AddressLatLng.OfficeAddress //office address of the company.
    let AddressesType = Addresses.AddressType
    let AddressFloors = Addresses.Floor
    let TruckDistance = Addresses.TruckDistance
    let Coordinates = Addresses.Coordinates
    let MileageCal = Addresses.MileageCal
    let CompanyZip = Addresses.CompanyZip
    let MeasurementUnit = Addresses.MeasurementUnit
    let lat = Coordinates.lat
    let lng = Coordinates.lng
    let [counter, setCounter] = useState({
        count: -1
    })

    const [BodyState ,setBodyState] = useState("MINI-LOADING")
    const [OriginAddress, setOriginAddress] = useState(Addresses.Origin.OriginAddress)
    const [OriginType, setOriginType] = useState(Addresses.Origin.OriginType)
    const [OriginFloor, setOriginFloor] = useState([])
    const [OriginFloorHash, setOriginFloorHash] = useState(Addresses.Origin.OriginFloorHash)
    const [DestinationFloorHash, setDestinationFloorHash] = useState(Addresses.Destination.DestinationFloorHash)
    const [DestinationFloor, setDestinationFloor] = useState([])
    const [DestinationType, setDestinationType] = useState(Addresses.Destination.DestinationType)
    const [DestinationTruckDistance, setDestinationTruckDistance] = useState(Addresses.Destination.TruckDistance)
    const [OriginTruckDistance, setOriginTruckDistance] = useState(Addresses.Origin.TruckDistance)
    const [DestinationAddress, setDestinationAddress] = useState(Addresses.Destination.DestinationAddress)
    const [RenderPage, setRenderPage] = useState(false)
    const [OriginElevatorValue, setOriginElevatorValue] = useState(Addresses.Origin.Elevator)
    const [DestinationElevatorValue, setDestinationElevatorValue] = useState(Addresses.Destination.Elevator)
    const [ExtraStops, setExtraStops] = useState({
        list: {}
    })

    useEffect(async () => {//fetch addresses details of an estimate.
        await axios({method: 'post', url: FetchExtraStopAddresses, params: {estimate_key: Elink}})
            .then((response) => {
                let Message = response.data.Message
                if (Message && Message.Status === 'failed'){
                    window.location.reload();
                }
                else{
                    setBodyState('Addresses record')
                    setOriginFloor(response.data[1])
                    setDestinationFloor(response.data[2])
                    let hash = {}
                    let count = -1
                    response.data[0].map((extra_stop, key) => {
                        count += 1
                        hash['extra_stop_added' + count] = {
                            Id: 'extra_stop_added' + count,
                            Address: extra_stop.Address,
                            Type: extra_stop.ExtraStopType,
                            TruckDistance: extra_stop.TruckDistance,
                            Floor: extra_stop.Floor,
                            ExtraStopHash: extra_stop.FloorHash,
                            Elevator: extra_stop.Elevator,
                            City: extra_stop.City ,
                            State: extra_stop.State ,
                            Zip: extra_stop.Zip

                        }
                    })
                    setExtraStops({
                        list: hash
                    })

                    setRenderPage(true)
                }

            })

    }, [])

    const FloorsOptions = [];

    const AddExtraStop = async () => {//component is used to add extra stops for an estimate.
        let count = counter.count
        setCounter({
            count: count + 1
        })
        let hash = ExtraStops.list
        hash['extra_stop' + counter.count] = {
            Id: 'extra_stop' + counter.count,
            Address: '',
            Type: AddressesType[0],
            TruckDistance: TruckDistance[0]['id'],
            Floor: [],
            Elevator: false ,
            City: "" ,
            State: "",
            Zip: ""
        }
        await setExtraStops({
            list: hash
        })
    }

    const RemoveExtraStop = (id) => {//component for removing/deleting extra stops
        let List = ExtraStops.list
        let ID = id
        delete List[ID]
        setExtraStops({
            list: List
        })
    }
    const handleExtraStopAddress = (e) => {//component is used to handle extra stops address.
        let newHash = ExtraStops
        let address = newHash.list[e.target.id]
        address.Address = e.target.value
        newHash.list[e.target.id] = address
        setExtraStops({
            list: newHash.list
        });
    }
    const handleExtraStopFloor = (e, id) => {//component is used to handle extra stops floor.
        let a = []
        let b = e.map(x => x.value)
        b.map((val) => {
            if (!a.includes(val) && (val !== '')) {
                a.push(val.toString())
            }
        })

        let newHash = ExtraStops
        let address = newHash.list[id]
        address.Floor = a
        newHash.list[id] = address
        setExtraStops({
            list: newHash.list
        });
    }
    const handleType = (e) => {//component is used to handle extra stops type.
        let newHash = ExtraStops
        let address = newHash.list[e.target.id]
        address.Type = e.target.value
        newHash.list[e.target.id] = address
        setExtraStops({
            list: newHash.list
        });
    }

    const handleTruckDistance = (e) => {//component is used to handle extra stops truck distance.
        let newHash = ExtraStops
        let address = newHash.list[e.target.id]
        address.TruckDistance = e.target.value
        newHash.list[e.target.id] = address
        setExtraStops({
            list: newHash.list
        });
    }


    const ValidateAddress = () => { //check the validations
        let element = document.getElementsByClassName("address-field")
        for (let i = 0; i < element.length; i++) {
            element[i].setAttribute('style', 'border: 2px solid none');
            if (element[i]["value"] === "") {
                element[i].setAttribute('style', 'border: 2px solid red');
                PageView.setAlertProperty({
                    Message: "Please enter a valid  address !...",
                    Type: "warning",
                    Show: true,
                    AutoHide: true
                })
                return false
            }
        }
    }

    const updateAddresses = async (ExtraStopList) => {//component is used to calculate travel and moving time and set google map according
        // to the updated addresses and send data to the web end.
        // ==================================validations for Origin, Destination and Extra floors START.================
        if (OriginFloor.length === 0) {
            PageView.setAlertProperty({
                //shows the alert message if origin floors is not selected.
                Message: "Floors is not selected in Origin address, please select any one floor",
                Type: 'warning', Show: true, AutoHide: true
            })
            return false;
        } else if (DestinationFloor.length === 0) {
            //shows the alert message if Destination floors is not selected.
            PageView.setAlertProperty({
                Message: "Floors is not selected in Destination address, please select any one floor",
                Type: 'warning', Show: true, AutoHide: true
            })
            return false;
        }
        let is_floor_selected_in_extra_stops = true
        Object.keys(ExtraStopList).map((extra_stop, i) => {
            if (ExtraStopList[extra_stop]['Floor'].length === 0) {
                is_floor_selected_in_extra_stops = false;
            }
        })
        if ( !is_floor_selected_in_extra_stops ) {
            PageView.setAlertProperty({
                //shows the alert message if floors is not selected in extra stop addresses.
                Message: "Floors is not selected in Extra stop address, please select any one floor",
                Type: 'warning', Show: true, AutoHide: true
            })
            return false;
        }
        // ==================================validations for Origin, Destination and Extra floors END.==================
        let checkValidation = await ValidateAddress()
        if (checkValidation === undefined) {
            let total_distance = 0;
            let total_dist = 0;
            let total_time = 0;
            let travel_min = 0;
            let moving_time = 0;
            let point_to_point_distance = 0;
            let my_route
            let directionsDisplay
            let myOptions = {
                zoom: 7,
                mapTypeId: window.google.maps.MapTypeId.ROADMAP,
                center: new window.google.maps.LatLng(lat, lng)
            }
            if (records.showMap) {
                 directionsDisplay = new window.google.maps.DirectionsRenderer(rendererOptions);
            }
            const directionsService = new window.google.maps.DirectionsService();
            if (lat != null && lng != null) {
                let extraStopHash = []
                if (records.showMap) {
                    let map = new window.google.maps.Map(document.getElementById("map_canvas"), myOptions);
                    directionsDisplay.setMap(map);
                }

                if (OfficeAddress) {
                    extraStopHash.push({
                        location: OriginAddress,
                        stopover: true
                    })
                    Object.keys(ExtraStopList).map((extra_stop, i) => {
                        let extraStop = ExtraStopList[extra_stop]
                        extraStopHash.push({
                            location: extraStop.Address,
                            stopover: true
                        })
                    })
                    extraStopHash.push({
                        location: DestinationAddress,
                        stopover: true
                    })
                }
                else{
                    Object.keys(ExtraStopList).map((extra_stop, i) => {
                        let extraStop = ExtraStopList[extra_stop]
                        extraStopHash.push({
                            location: extraStop.Address,
                            stopover: true
                        })
                    })
                }
                await directionsService.route(//update addresses on the google map
                    {
                        origin: OfficeAddress ? OfficeAddress : OriginAddress,
                        destination: OfficeAddress ? OfficeAddress : DestinationAddress,
                        waypoints: extraStopHash,
                        travelMode: window.google.maps.TravelMode.DRIVING

                    },
                    (result, status) => {
                        if (status === window.google.maps.DirectionsStatus.OK) {
                            if (records.showMap) {
                                directionsDisplay.setDirections(result);
                            }
                            my_route = result.routes[0];

                            if (MileageCal === 1) {
                                for (let i = 0; i < my_route.legs.length; i++) {
                                    total_distance += my_route.legs[i].distance.value;
                                    total_time += my_route.legs[i].duration.value;
                                }
                                for (let i = 1; i < my_route.legs.length - 1; i++) {
                                    moving_time += my_route.legs[i].duration.value;
                                    point_to_point_distance += my_route.legs[i].distance.value;
                                }
                                travel_min = ((total_time - moving_time) / 60).toFixed(2);
                                moving_time = (moving_time / 60).toFixed(2);
                            }
                            else {
                                for (let i = 0; i < my_route.legs.length; i++) {
                                    total_distance += my_route.legs[i].distance.value;
                                    total_time += my_route.legs[i].duration.value;
                                }
                                moving_time = (total_time / 60).toFixed(2);
                                point_to_point_distance = total_distance
                            }
                            point_to_point_distance = (point_to_point_distance / 1609.344).toFixed(2);
                            total_distance = (total_distance / 1609.344).toFixed(2);

                        } else {
                            PageView.setAlertProperty({//shows the alert message if there is an error occurs while updating the addresses on the map.
                                Message: "One of the Address is not found ..",
                                Type: 'warning',
                                Show: true,
                                AutoHide: true
                            })
                            console.error(`error fetching directions ${result}`);
                        }
                    }
                );
            } else {
                let address = CompanyZip
                let lat = '';
                let lng = '';
                let geocoder = new window.google.maps.Geocoder();
                geocoder.geocode({'address': address}, function (results, status) {
                    if (status == window.google.maps.GeocoderStatus.OK) {
                        lat = results[0].geometry.location.lat();
                        lng = results[0].geometry.location.lng();

                        let extraStopHash = []
                        if (records.showMap) {
                            let map = new window.google.maps.Map(document.getElementById("map_canvas"), myOptions);
                            directionsDisplay.setMap(map);
                        }

                        if (OfficeAddress) {
                            extraStopHash.push({
                                location: OriginAddress,
                                stopover: true
                            })
                            Object.keys(ExtraStops.list).map((extra_stop, i) => {
                                extraStopHash.push({
                                    location: extra_stop.Address,
                                    stopover: true
                                })
                            })
                            extraStopHash.push({
                                location: DestinationAddress,
                                stopover: true
                            })
                        }
                       else{
                            Object.keys(ExtraStops.list).map((extra_stop, i) => {
                                extraStopHash.push({
                                    location: extra_stop.Address,
                                    stopover: true
                                })
                            })
                       }
                        directionsService.route(
                            {
                                origin: OfficeAddress ? OfficeAddress : OriginAddress,
                                destination: OfficeAddress ? OfficeAddress : DestinationAddress,
                                waypoints: extraStopHash,
                                travelMode: window.google.maps.TravelMode.DRIVING

                            },
                            (result, status) => {
                                if (status === window.google.maps.DirectionsStatus.OK) {
                                    if (records.showMap) {
                                        directionsDisplay.setDirections(result);
                                    }
                                    my_route = result.routes[0];

                                    if (MileageCal === 1) {
                                        for (let i = 0; i < my_route.legs.length; i++) {
                                            total_distance += my_route.legs[i].distance.value;
                                            total_time += my_route.legs[i].duration.value;
                                        }
                                        for (let i = 1; i < my_route.legs.length - 1; i++) {
                                            moving_time += my_route.legs[i].duration.value;
                                            point_to_point_distance += my_route.legs[i].distance.value;
                                        }
                                        travel_min = ((total_time - moving_time) / 60).toFixed(2);
                                        moving_time = (moving_time / 60).toFixed(2);
                                    }
                                    else {
                                        for (let i = 0; i < my_route.legs.length; i++) {
                                            total_distance += my_route.legs[i].distance.value;
                                            total_time += my_route.legs[i].duration.value;
                                        }
                                        moving_time = (total_time / 60).toFixed(2);
                                        point_to_point_distance = total_distance
                                    }
                                    point_to_point_distance = (point_to_point_distance / 1609.344).toFixed(2);
                                    total_distance = (total_distance / 1609.344).toFixed(2);
                                } else {
                                    PageView.setAlertProperty({//shows the alert message
                                        Message: "One of the Address is not found ..",
                                        Type: 'warning',
                                        Show: true,
                                        AutoHide: true
                                    })
                                    console.error(`error fetching directions ${result}`);
                                }
                            }
                        );

                    } else {
                        alert("zipcode not found, please set your company zipcode.");
                    }
                });
            }

            await records.setAddressesModal(false) // use to close or hide the modal
            let cookie = document.cookie.split('employee_id=')[1] //fetch that if current employee is admin or not
            let geocoder = new window.google.maps.Geocoder();
            const getAddressDetails =  async (address, type) => {
                let addressType = ""
                await geocoder.geocode({'address': address}, await function (results, status) {
                    if (status == window.google.maps.GeocoderStatus.OK) {
                        for (let i = 0; i < (results[0].address_components.length); i++) {
                            if (results[0].address_components[i].types[0] == type) {
                                addressType = results[0].address_components[i].long_name;
                            }
                        }
                    }
                })
                return addressType
            }

            let OriginDetails = {}
            OriginDetails["Address"] = OriginAddress
            OriginDetails["Type"] = OriginType
            OriginDetails["Floor"] = OriginFloor
            OriginDetails["City"] = await getAddressDetails(OriginAddress,"locality")
            OriginDetails["State"] = await getAddressDetails(OriginAddress,"administrative_area_level_1")
            OriginDetails["Zip"] = await getAddressDetails(OriginAddress,"postal_code")
            OriginDetails["TruckDistance"] = OriginTruckDistance
            OriginDetails["OriginElevator"] = OriginElevatorValue

            let DestinationDetails = {}
            DestinationDetails["Address"] = DestinationAddress
            DestinationDetails["Type"] = DestinationType
            DestinationDetails["Floor"] = DestinationFloor
            DestinationDetails["City"] = await getAddressDetails(DestinationAddress,"locality")
            DestinationDetails["State"] = await getAddressDetails(DestinationAddress,"administrative_area_level_1")
            DestinationDetails["Zip"] = await getAddressDetails(DestinationAddress,"postal_code")
            DestinationDetails["TruckDistance"] = DestinationTruckDistance
            DestinationDetails["DestinationElevator"] = DestinationElevatorValue

            let ExtraStops = ExtraStopList
            let Calculation = {}
            Calculation["total_distance"] = total_distance
            Calculation["total_time"] = total_time
            Calculation["travel_min"] = travel_min
            Calculation["moving_time"] = moving_time
            Calculation["est_distance"] = total_distance
            Calculation["point_to_point_distance"] = point_to_point_distance
            await axios({
                method: 'post',
                url: UpdateAddresses,
                data: {
                    estimate_key: Elink, employee_key: cookie, extra_stop_list: ExtraStops,
                    origin_details: OriginDetails, destination_details: DestinationDetails, calculations: Calculation
                }
            }).then((response) => {
                let Message = response.data.Message
                if(Message && Message.Status === "failed"){
                    window.location.reload();
                }
                else{
                    if (Message == undefined) {
                        let adressLatLang = { ...Record.AddressLatLng, 'Destination': response.data[4]['DestinationAddress'], 'Origin': response.data[3]['OriginAddress'] }
                        records.SetCP_PageDetails({
                            ...records.CP_PageDetails,
                            EstimateAddress: {
                                ...records.CP_PageDetails.EstimateAddress,
                                OriginAddress: response.data[0],
                                DestinationAddress: response.data[1],
                                ExtraStops: response.data[2],
                                Origin: response.data[3],
                                Destination: response.data[4],
                                ExtraStopsRecord: response[5]
                            },
                            AddressLatLng: adressLatLang,
                            ExtraStopAddress: response.data[5]
                        })
                        PageView.setAlertProperty({//shows the alert message
                            Message: 'Addresses are updated successfully ...',
                            Type: 'warning',
                            Show: true,
                            AutoHide: true
                        })
                    } else {
                        PageView.setAlertProperty({//shows the alert message
                            Message: Message.Text,
                            Type: Message.Type,
                            Show: true,
                            AutoHide: true
                        })
                    }
                }
            })

        }
    }

    let rendererOptions = {
        draggable: true
    };

    const ChangeOriginFloors = (e) => {//Update origin floors
        let a = []
        let b = e.map(x => x.value)
        b.map((val) => {
            if (!a.includes(val) && (val !== '')) {
                a.push(val.toString())
            }
        })
        setOriginFloor(a)
    }

    const ChangeDestinationFloors = (e) => {//update destination floors
        let a = []
        let b = e.map(x => x.value)
        b.map((val) => {
            if (!a.includes(val) && (val !== '')) {
                a.push(val.toString())
            }
        })
        setDestinationFloor(a)
    }

    const extraStopElevator = (value, id) => {//update extra stop elevator option.
        let newHash = ExtraStops
        let address = newHash.list[id]
        address.Elevator = value
        newHash.list[id] = address
        setExtraStops({
            list: newHash.list
        });
    }
    const destinationElevator = (value) => {//update destination elevator option.
        setDestinationElevatorValue(value)
    }
    const originElevator = (value) => {//update origin elevator option.
        setOriginElevatorValue(value)
    }

    if (BodyState === 'MINI-LOADING') {
        return (
            <Loader For={'AJAX'} UniqueId={'4'}/>
        );
    } else {

        return (
            RenderPage ?
                <table className="table small" style={{textAlign: "center"}}>
                    <tbody>
                    <tr>
                        <td className="test-td" style={{fontSize: "120%"}}>
                            <b>ORIGIN :</b>
                        </td>
                    </tr>
                    <tr>
                        <td className="test-td">
                            Origin Address
                        </td>
                        <td className="test-td">
                            <input className='form-control address-field' value={OriginAddress}
                                   onChange={(e) => setOriginAddress(e.target.value)}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td className="test-td">
                            Origin
                        </td>
                        <td className="test-td">
                            <select className="custom-select address-field" value={OriginType}
                                    onChange={(e) => setOriginType(e.target.value)}>
                                {AddressesType.map((data) => {
                                    return (
                                        <option key={data[0]} value={data[0]}>{data[1]}</option>
                                    )
                                })
                                }
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className="test-td">
                            Origin Floor
                        </td>
                        <td className="test-td">
                            {AddressFloors.map((addr_floor, key) => {
                                FloorsOptions.push({value: addr_floor.floor, label: addr_floor.floor})
                            })}

                            <Select isMulti className="custom_select address-field floor-select" options={FloorsOptions}
                                    onChange={ChangeOriginFloors}
                                    defaultValue={OriginFloorHash}></Select>
                        </td>
                    </tr>
                    <tr>
                        <td className="test-td">
                            <label htmlFor="originElevator"> Elevator</label>
                        </td>
                        <td className="test-td">
                            <label className="switch">
                                <input type="checkbox" id='originElevator'
                                       onChange={(e) => {
                                           originElevator(e.target.checked)
                                       }}
                                       checked={OriginElevatorValue}/>
                                <span className="slider round"></span>
                            </label>
                        </td>
                    </tr>
                    <tr>
                        <td className="test-td">
                            Origin Truck Distance
                        </td>
                        <td className="test-td">
                            <select className="custom-select address-field" value={OriginTruckDistance}
                                    onChange={(e) => setOriginTruckDistance(e.target.value)}>
                                {TruckDistance.map((truck_dist, key) => {
                                    return (
                                        <option key={"truck_dist" + key}
                                                value={truck_dist.id}>{truck_dist.distance}</option>
                                    )
                                })}

                            </select>
                        </td>
                    </tr>

                    {/*<div className={Object.keys(ExtraStops.list).length >0 ?"extra_stop_addresses":"extra_stop"}>*/}
                    {Object.keys(ExtraStops.list).length > 0 ?
                        Object.keys(ExtraStops.list).map((extra_stop, i) => {
                            let extraStop = ExtraStops.list[extra_stop]
                            return (
                                // <div key={`ExtraStopKey${i}`} style={{paddingLeft:"10px"}} >

                                <>
                                    <tr>
                                        <td style={{paddingTop: "3%"}} className="test-td">
                                            <div className="btn btn-warning remove-person-btn "
                                                 style={{fontSize: "94%"}}
                                                 onClick={() => RemoveExtraStop(extraStop.Id)}>
                                                <b>Remove Extra Stop</b></div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="test-td"
                                            style={{paddingTop: "3%", fontSize: "120%"}}>
                                            <b>EXTRA STOP :</b>
                                        </td>
                                    </tr>
                                    <tr style={{paddingTop: "5px"}}>
                                        <td className="test-td">Extra Stop Address</td>
                                        <td className="test-td">
                                            <input className='form-control address-field'
                                                   style={{marginBottom: "1%"}}
                                                   value={extraStop.Address}
                                                   id={extraStop.Id}
                                                   onChange={(e) => handleExtraStopAddress(e)}/>
                                        </td>
                                    </tr>
                                    <tr style={{paddingTop: "3px"}}>
                                        <td className="test-td">Extra Stop</td>
                                        <td className="test-td"><select id={extraStop.Id}
                                                                        style={{marginBottom: "1%"}}
                                                                        className="custom-select address-field"
                                                                        value={extraStop.Type}
                                                                        onChange={(e) => handleType(e)}>
                                            {AddressesType.map((data, key) => {
                                                return (
                                                    <option key={data[0] + key + "extra_stop"}
                                                            value={data[0]}>{data[1]}
                                                    </option>
                                                )
                                            })
                                            }


                                        </select></td>
                                    </tr>
                                    <tr style={{paddingTop: "3px", marginBottom: "1%"}}>
                                        <td className="test-td"> Extra Stop Floor</td>
                                        <td className="test-td">

                                            <Select id={extraStop.Id} isMulti
                                                    className="custom_select address-field floor-select"
                                                    options={FloorsOptions}
                                                    onChange={(e) => handleExtraStopFloor(e, extraStop.Id)}
                                                    defaultValue={extraStop.ExtraStopHash}></Select>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="test-td">
                                            <label htmlFor="extraStopElevator" className="test-td">Elevator</label>
                                        </td>
                                        <td className="test-td">
                                            <label className="switch">
                                                <input type="checkbox" id='extraStopElevator'
                                                       onChange={(e) => {
                                                           extraStopElevator(e.target.checked, extraStop.Id)
                                                       }}
                                                       checked={extraStop.Elevator}/>
                                                <span className="slider round"
                                                      style={{marginBottom: "1%", marginTop: "1%"}}>
                                                                        </span>
                                            </label>
                                        </td>
                                    </tr>

                                    <tr style={{paddingTop: "3px"}}>
                                        <td className="test-td">Extra Stop Truck Distance</td>
                                        <td className="test-td">
                                            <select id={extraStop.Id}
                                                    className="custom-select address-field"
                                                    value={extraStop.TruckDistance}
                                                    style={{marginBottom: "1%"}}
                                                    onChange={(e) => handleTruckDistance(e)}>
                                                {TruckDistance.map((truck_dist, key) => {
                                                    return (
                                                        <option key={"truck_dist_extra_stop" + key}
                                                                value={truck_dist.id}>
                                                            {truck_dist.distance}
                                                        </option>
                                                    )
                                                })}
                                            </select></td>
                                    </tr>
                                    {/*</form>*/}
                                </>
                            )
                        })

                        : <></>
                    }
                    {/*</div>*/}

                    <tr>
                        <td colSpan={2}
                            style={{textAlign: "center", paddingTop: "3%", borderTop: 0, paddingBottom: "3%"}}>
                            <button className="btn btn-danger contact-btns-bg"
                                    style={{backgroundColor: "red", fontSize: "94%"}}
                                    onClick={() => AddExtraStop()}
                            ><b>Add Extra Stop</b>
                            </button>
                        </td>
                    </tr>
                    <tr>
                        <td className="test-td" style={{fontSize: "120%"}}><b>DESTINATION :</b></td>
                    </tr>
                    <tr>
                        <td className="test-td">
                            Destination Address
                        </td>
                        <td className="test-td">
                            <input className='form-control address-field' value={DestinationAddress}
                                   onChange={(e) => setDestinationAddress(e.target.value)}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td className="test-td">
                            Destination
                        </td>
                        <td className="test-td">
                            <select className="custom-select address-field" value={DestinationType}
                                    onChange={(e) => setDestinationType(e.target.value)}>
                                {AddressesType.map((data) => {
                                    return (
                                        <option key={data[0]} value={data[0]}>{data[1]}</option>
                                    )
                                })
                                }
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className="test-td">
                            Destination Floor
                        </td>
                        <td className="test-td">
                            <Select isMulti className="custom_select address-field floor-select" options={FloorsOptions}
                                    onChange={ChangeDestinationFloors}
                                    defaultValue={DestinationFloorHash}></Select>
                        </td>
                    </tr>
                    <tr>
                        <td className="test-td">
                            <label htmlFor="destinationElevator">Elevator</label>
                        </td>
                        <td className="test-td">
                            <label className="switch">
                                <input type="checkbox" id='destinationElevator'
                                       onChange={(e) => {
                                           destinationElevator(e.target.checked)
                                       }}
                                       checked={DestinationElevatorValue}/>
                                <span className="slider round"></span>
                            </label>
                        </td>
                    </tr>

                    <tr>
                        <td className="test-td">
                            Destination Truck Distance
                        </td>
                        <td className="test-td">
                            <select className="custom-select address-field" value={DestinationTruckDistance}
                                    onChange={(e) => setDestinationTruckDistance(e.target.value)}>
                                {TruckDistance.map((truck_dist, key) => {
                                    return (
                                        <option key={"truck_dist_dest" + key}
                                                value={truck_dist.id}>{truck_dist.distance}</option>
                                    )
                                })}
                            </select>
                        </td>
                    </tr>

                    <tr>
                        <td colSpan={2} style={{textAlign: "center", paddingTop: "4%", borderTop: "0px"}}>
                            <button className="btn btn-warning contact-btns-bg bg-clr-info"
                                    onClick={() => {
                                        updateAddresses(ExtraStops.list)
                                    }}
                            >Update
                            </button>
                        </td>
                    </tr>
                    </tbody>
                </table>
                : <></>
        )
    }
}
